import React, { useEffect } from 'react'
import { Card, Grid, Typography, makeStyles, FormControl, MenuItem, Button, Select, FormControlLabel, Checkbox } from "@material-ui/core";
import Buscador from '../../../actions/ui/Buscador';
import { useState } from 'react';
import { generatePDFHceAfiliado, setActiveBreadcrumbHce } from '../../../actions/hce/hceActions';
import { useDispatch, useSelector } from 'react-redux';
import { MENU_HCE, OBRAS_SOCIALES } from '../../../utils/constants';
import {

    ValidatorForm,
} from 'react-material-ui-form-validator';
import { getObrasSociales } from '../../../actions/afiliado';
import { startAlerta } from '../../../actions/ui/alertas';

const useStyles = makeStyles((theme) => ({
    title: {
        color: theme.palette.primary.main,
    },
}));


export const BusquedaPorPaciente = (props) => {
    const classes = useStyles();
    // const { efectorMedico } = props;
    const tipoBusqueda = "Todos";
    const dispatch = useDispatch();
    const altaBaja = "Todos";
    const [value, setValue] = useState(null);
    const [historiaClinica, setHistoriaClinica] = useState(false);
    const [historiaClinicaOdontologica, setHistoriaClinicaOdontologica] = useState(false);
    // const [idEfectorRed, setIdEfectorRed] = useState(efectorMedico[0]?.idEfectorRed);
    // const [idCentroMedico, setIdCentroMedico] = useState('');
    const [idObraSocial, setIdObraSocial] = useState(OBRAS_SOCIALES.OSPEDYC);
    // const [openModalHce, setOpenModalHce] = useState(false);
    // const { relEfectorCMEspe } = useSelector(
    //     (state) => state.hce
    // );
    // const { recetaSeleccionada = {} } = useSelector((state) => state.recetasDigitales);
    const { obrasSociales = [] } = useSelector((state) => state.obrasSociales);

 

    // useEffect(() => {
    //     if (idEfectorRed > 0) {
    //         dispatch(traerRelacionEfectorCMEspecialidad(idEfectorRed));
    //     }
    // }, [idEfectorRed]);

    // useEffect(() => {
    //     if (recetaSeleccionada?.idAfiliado) {
    //         setOpenModalHce(true);
    //         ////Traer de nuevo la lista de recetas del afiliado
    //     }
    // }, [dispatch, recetaSeleccionada]);

    useEffect(() => {
        if (obrasSociales.length === 0)
            dispatch(getObrasSociales());
        setIdObraSocial(idObraSocial !== null ? idObraSocial : OBRAS_SOCIALES.OSPEDYC);
    }, [dispatch]);

    const onClose = () => {
        dispatch(setActiveBreadcrumbHce(MENU_HCE.DESELECCIONAR));
    };

    const onSubmitHandler = () => {
        // const item = {
        //     idAfiliado: idObraSocial === OBRAS_SOCIALES.OSPEDYC ? value.id_afiliado : null,
        //     NombreApellido: value.apellido_y_nombre,
        //     idEfector: idEfectorRed,
        //     idAfiliadoExterno: idObraSocial !== OBRAS_SOCIALES.OSPEDYC ? value.id_afiliado : null,
        //     nroDocumento : value?.nro_doc
        // }
        // dispatch(
        //     TraerRecordatorioGeneral(item.idAfiliado, item.idAfiliadoExterno,item.idEfector, 0),
        //   );
        //   dispatch(
        //     TraerRecordatorioPropio(
        //       item.idAfiliado,
        //       item.idAfiliadoExterno,
        //       item.idEfector,
        //       1,
        //       () => {
        //         setOpenModalHce(true);
        //       },
        //     ),
        //   );
        //   if (item?.idAfiliado) {
        //     dispatch(FetchDataAfiliadoHCE(item?.idAfiliado));
        //   }
        //   else {
        //     dispatch(FetchDataAfiliadoExternoHCE(idObraSocial, item?.nroDocumento))
        //   }
        //   dispatch(TraerProblemasAfiliado(item?.idAfiliado, item?.idAfiliadoExterno));
        //   if (item?.idAfiliado) {
        //     dispatch(getAutopercepcionPorAfiliadoHCE(item.idAfiliado));
        //   }
        //   dispatch(traerEstadosProblemas());
        //   //setOpenModalHce(true);
        //   dispatch(setHceSelec(item));
        //   dispatch(autopercepcionClear());
        //   setOpenModalHce(true)

    };

    const exportarPDF = () => {
        const item = {
            idAfiliado: idObraSocial === OBRAS_SOCIALES.OSPEDYC ? value.id_afiliado : null,
            idAfiliadoExterno: idObraSocial !== OBRAS_SOCIALES.OSPEDYC ? value.id_afiliado : null
        }
        if (historiaClinica === true || historiaClinicaOdontologica === true){
            dispatch(generatePDFHceAfiliado(item.idAfiliado, item.idAfiliadoExterno, historiaClinica, historiaClinicaOdontologica));
        }
       else {
        dispatch(startAlerta("Debe Seleccionar al menos una opción", "error"))
       }
    }

    return (
        <Grid item xs={12} sm={6} lg={5} xl={5}>
            {/* {openModalHce && (
                <ModalHce
                    open={openModalHce}
                    closeModalHandler={() => setOpenModalHce(false)}
                    hce={item}
                    disabled={false}

                />
            )} */}
            <ValidatorForm onSubmit={onSubmitHandler}>
                <Grid
                    container
                    spacing={2}
                    justify="center"
                    alignItems="center"
                    component={Card}
                    style={{ marginTop: "2rem", marginBottom: "2rem", padding: "0 1em" }}
                >
                    {/* <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                        {Array.isArray(efectorMedico) && efectorMedico.length > 0 && (
                            <SelectValidator
                                fullWidth
                                label="Seleccionar Profesional"
                                name="idEfectorRed"
                                value={idEfectorRed}
                                onChange={(e) => setIdEfectorRed(e.target.value)}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            >
                                {efectorMedico.map((item) => (
                                    <MenuItem
                                        key={item.idEfectorRed}
                                        value={item.idEfectorRed}
                                    >
                                        {`${item.nombreEfector}`}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        )}
                    </Grid> */}
                    {/* <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                        {Array.isArray(relEfectorCMEspe) &&
                            relEfectorCMEspe.length > 0 && (
                                <SelectValidator
                                    fullWidth
                                    label="Seleccionar Centro Médico"
                                    name="idCentroMedico"
                                    value={idCentroMedico}
                                    onChange={(e) => setIdCentroMedico(e.target.value)}
                                    validators={['required']}
                                    errorMessages={['Este campo es requerido']}
                                >
                                    {relEfectorCMEspe.map((item) => (
                                        <MenuItem
                                            key={item.id_centroMedico}
                                            value={item.id_centroMedico}
                                        >
                                            {`${item.descripcion_Centro}`}
                                        </MenuItem>
                                    ))}
                                </SelectValidator>
                            )}
                    </Grid> */}
                    <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                        {Array.isArray(obrasSociales) && obrasSociales.length > 0 && (
                            <Select
                                fullWidth
                                margin="normal"
                                label="OS"
                                name="idObraSocial"
                                value={idObraSocial}
                                onChange={(e) => {
                                    setIdObraSocial(e.target.value);
                                    //handleAfiliadoSeleccionado(null);
                                    //setTextoBuscado("");
                                }}
                                style={{
                                    // width: !props.hideTitle && 500,
                                    padding: 6,
                                    backgroundColor: "#FAFAFA",
                                    borderRadius: "5px",
                                }}
                            >
                                {obrasSociales.map((ObraSocial) => (
                                    <MenuItem
                                        key={ObraSocial.idObraSocial}
                                        value={ObraSocial.idObraSocial}
                                    >
                                        {ObraSocial.siglas} - {ObraSocial.razonSocial}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    </Grid>
                    <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                        <Typography
                            align="center"
                            variant="button"
                            color="secondary"
                            style={{ paddingTop: 6 }}
                        >
                            <span className={classes.title}>SELECCIONAR AFILIADO/A</span>
                        </Typography>
                        <FormControl variant="outlined" margin="normal" fullWidth={true}>
                            {idObraSocial === OBRAS_SOCIALES.OSPEDYC && (
                                <Buscador
                                    value={value}
                                    variant="outlined"
                                    setValue={(val) => setValue(val)}
                                    label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                                    noOptionText={"No se encuentra beneficiaria/o"}
                                    endpoint={(texto) =>
                                        `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                                    }
                                    getOptionLabel={(option) =>
                                        `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                                    }
                                    renderOption={(option) => (
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <span
                                                style={
                                                    option.fecha_baja === null
                                                        ? { color: "green" }
                                                        : { color: "red" }
                                                }
                                            >
                                                {`${option.apellido_y_nombre}`}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                }}
                                            >
                                                {" "}
                                                {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                                            </span>
                                        </div>
                                    )}
                                />
                            )}
                            {idObraSocial !== OBRAS_SOCIALES.OSPEDYC && (
                                <Buscador
                                    value={value}
                                    variant="outlined"
                                    setValue={(val) => {
                                        setValue(val)
                                    }}
                                    label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                                    noOptionText={"No se encuentra beneficiaria/o"}
                                    endpoint={(texto) =>
                                        `AfiliadosExternos/validarAfiliadoExterno/${idObraSocial}/${texto}`
                                    }
                                    getOptionLabel={(option) =>
                                        `${option?.apellido_y_nombre} ${option?.carnet} ${option?.cuil} ${option?.nro_doc}`
                                    }
                                    renderOption={(option) => (
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <span
                                                style={
                                                    option?.fecha_baja === null
                                                        ? { color: "green" }
                                                        : { color: "red" }
                                                }
                                            >
                                                {`${option?.apellido_y_nombre}`}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                }}
                                            >
                                                {" "}
                                                {`Nro Afi:${option?.carnet} - CUIL:${option?.cuil}`}
                                            </span>
                                        </div>
                                    )}
                                />
                            )}
                            <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                                <FormControlLabel
                                    control={<Checkbox checked={historiaClinica} onChange={(e) => setHistoriaClinica(e.target.checked)} />}
                                    label="Historia Clínica"
                                />
                            </Grid>

                            <Grid item style={{ display: "flex", flexDirection: "column" }} xs={8}>
                                <FormControlLabel
                                    control={<Checkbox checked={historiaClinicaOdontologica} onChange={(e) => setHistoriaClinicaOdontologica(e.target.checked)} />}
                                    label="Historia Clínica Odontológica"
                                />
                            </Grid>
                            <div
                                style={{
                                    margin: '1rem 0',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-evenly',
                                }}
                            >
                                <Button variant="contained" color="primary" onClick={onClose}>
                                    Cancelar
                                </Button>
                                {/* <Button
                                    type="submit"
                                    variant="contained"
                                    //onClick={buscar}
                                    color="primary"
                                >
                                    Ingresar a HCE
                                </Button> */}
                                <Button
                                    //type="submit"
                                    variant="contained"
                                    onClick={exportarPDF}
                                    color="primary"
                                >
                                    Impresión PDF
                                </Button>
                            </div>
                        </FormControl>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Grid>
    )
}
